import gql from 'graphql-tag';

export default gql`
  mutation UpdateProperty(
    $id: ID!
    $address: String
    $size: Float
    $valuation: Float
    $code: String
    $suburb: String
    $image: FileUpdateInput
    $rooms: Float
    $erfNumber: String
    $salesAgent: String
    $status: PropertyStatus
    $stakeholders: StakeholderUpdateInput
    $type: PropertyType
  ) {
    updateProperty(
      data: {
        address: $address
        size: $size
        valuation: $valuation
        code: $code
        suburb: $suburb
        image: $image
        rooms: $rooms
        erfNumber: $erfNumber
        salesAgent: $salesAgent
        status: $status
        stakeholders: $stakeholders
        type: $type
      }
    id: $id
    ) {
      createdAt
      updatedAt
      id
      address
      size
      valuation
      code
      suburb
      image {
        id
        original
        scaled
        thumbnail
        id
      }
      rooms
      erfNumber
      salesAgent
      status
      stakeholders {
        createdAt
        updatedAt
        id
        firstName
        lastName
        dob
        country
        homeNumber
        cellNumber
        email
        idNumber
        residentialAddress
        postalAddress
        status
        role
      }
      type
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/UpdateProperty.ts